// Kept as module.exports for compatibility with tailwind.config.js
module.exports = {
  primary: "#0D9E90",
  secondary: "#1EB087",
  error: "#EF2C20",
  // error:"#FF5F5F",
  warning: "#E7B128",
};
